import { Column } from '~components/table-view';

// Columns for the "not copied" table in the bulk-copy wizard (steps 3 and 4). Mirrors
// bulkCopyPreviewList's identity columns so the two tables line up visually, but swaps the
// removed/price-missing counts for the failure reason — these budgets were never copied, so there is
// nothing to count. `reason` comes straight from the API (see BudgetFailureRow).
const columns: Column[] = [
  {
    id: 'client_name',
    header: 'Client Name',
    type: 'text',
  },
  {
    id: 'ref',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'package',
    header: 'Package',
    type: 'text',
  },
  {
    id: 'reason',
    header: 'Reason Not Copied',
    type: 'text',
  },
];

/**
 * Step 4 (results) variant. After a copy has run, the not-copied table mixes budgets whose data can be fixed
 * and retried with ids that can never be copied (deleted, or another company's) — this column is what tells
 * them apart, so a coordinator knows which rows the Retry button will actually pick up. Omitted at step 3,
 * where nothing has been attempted and there is no retry to offer.
 */
export const columnsWithRetryable: Column[] = [
  ...columns,
  {
    id: 'retry',
    header: 'Can Retry',
    type: 'text',
  },
];

export default columns;
